import React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';
import {CheckBox, withTheme} from '@rneui/themed';

import Text from '../themed/Text';
import ValidationMessage from '../themed/ValidationMessage';

type WeakPasswordProps = {
  onChange: (value: boolean) => void;
  checked?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
  iconColor?: string;
  errorMessage?: string;
};

const defaultStyle = StyleSheet.create({
  containerStyle: {
    paddingVertical: 8,
    paddingHorizontal: 10,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
  },
});

/**
 * Show a message that weak password is used and checkbox to continue with weak password
 * @returns
 */
function WeakPassword({
  containerStyle,
  checked,
  onChange,
  iconColor,
  errorMessage,
}: WeakPasswordProps) {
  return (
    <View>
      <CheckBox
        wrapperStyle={{gap: 8}}
        containerStyle={[defaultStyle.containerStyle, containerStyle]}
        checked={!!checked}
        checkedColor={iconColor}
        uncheckedColor={iconColor}
        onPress={() => onChange(!checked)}
        iconType="material-icons"
        checkedIcon={'check-box'}
        uncheckedIcon={'check-box-outline-blank'}
        title={
          <Text variant="caption">
            This password has been found in a list of passwords that was leaked
            from other websites. By ticking this box you acknowledge that you
            wish to continue with this password.
          </Text>
        }
      />
      <ValidationMessage>{errorMessage || ' '}</ValidationMessage>
    </View>
  );
}

export {WeakPassword};

export default withTheme(WeakPassword, 'WeakPassword');

declare module '@rneui/themed' {
  export interface ComponentTheme {
    WeakPassword: Partial<WeakPasswordProps>;
  }
}
